import { scrollToEl, addHashToURL, headerOffsetHeight } from './helpers';

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
document.addEventListener('click', (e) => {
	if (e.target.hash) {
		const getURL = e.target.getAttribute('href');
		if (getURL.startsWith('#')) {
			e.preventDefault();
		}
		const { target } = e;
		const { hash, pathname, hostname } = target;
		const { pathname: windowPathname, hostname: windowHostname } = window.location;
		const regex = /^\//;

		if (windowPathname.replace(regex, '') === pathname.replace(regex, '') && windowHostname === hostname) {
			const el = document.querySelector(hash) || document.querySelector(`[name=${hash.slice(1)}]`);
			scrollToEl(el, headerOffsetHeight(el) + 100);
			console.log(headerOffsetHeight(el));
			addHashToURL(hash);
			return false;
		}
	}

	return true;
});
